export enum ROUTE_MOVES {
  LIST = 'moves-list',
  DETAIL = 'moves-list-detail',
  UPLOAD = 'moves-upload',
  UPLOAD_SUCCESS = 'moves-upload-success',
}
